/**
 * Geteilte Formatter für KPI-Anzeige (EUR-Cents → EUR-String, Prozent, Vorzeichen-Farben).
 * Bewusst getrennt von dem allgemeinen format.ts wenn das existiert — diese sind KPI-spezifisch
 * mit Null-Handling für „—".
 */

export function formatEur(cents: number | null | undefined): string {
  if (cents === null || cents === undefined) return "—";
  return (cents / 100).toLocaleString("de-DE", { style: "currency", currency: "EUR" });
}

export function formatPercent(p: number | null | undefined, fractionDigits = 2): string {
  if (p === null || p === undefined) return "—";
  return `${p > 0 ? "+" : ""}${p.toFixed(fractionDigits)} %`;
}

export function formatEurCompact(cents: number): string {
  const eur = cents / 100;
  const abs = Math.abs(eur);
  let str: string;
  if (abs >= 1_000_000) str = `${(eur / 1_000_000).toFixed(2)}M`;
  else if (abs >= 1_000) str = `${(eur / 1_000).toFixed(1)}k`;
  else str = `${eur.toFixed(0)}`;
  const sign = eur > 0 ? "+" : "";
  return `${sign}${str} €`;
}

export function colorClass(v: number | null): string {
  if (v === null || v === 0) return "text-slate-700";
  return v > 0 ? "text-green-700" : "text-red-700";
}
